import React, { useEffect, useState } from "react";
import { Form, Flex, theme, type UploadFile } from "antd";
import { HeaderApp } from "../../shared";
import type { UploadContractData } from "../types/uploadContract";
import { URL_FILES } from "../../../constans/apis";
import openNotification from "../../../utils/openNotification";
import { useCreateContract } from "../hooks/useCreateContract";
import { useUploadFile } from "../../../lib/files/hooks/useUploadFile";
import { useNavigate, useSearchParams } from "react-router-dom";
import ContractFrom from "../components/ContractFrom";

const UploadContract: React.FC = () => {
  const [form] = Form.useForm();
  const { token } = theme.useToken();
  const [fileList, setFileList] = useState<UploadFile[]>([]);

  const { mutate: createContractMutation, isPending: isCreating } = useCreateContract();
  const { mutateAsync: uploadFileMutation, isPending: isUploading } = useUploadFile();

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  // Cuando se llega desde el detalle de una cotización completada
  // (`/contrato/nuevo?id_quote=123`) el select llega ya seleccionado.
  const quoteIdParam = Number(searchParams.get("id_quote"));

  useEffect(() => {
    if (Number.isInteger(quoteIdParam) && quoteIdParam > 0) {
      form.setFieldValue("id_quote", quoteIdParam);
    }
  }, [quoteIdParam, form]);

  const handleFinish = async (values: UploadContractData) => {
    try {
      let uuidFile = null;
      const hasFile = fileList.length > 0;

      if (hasFile) {
        const resFile = await uploadFileMutation({
          file: fileList[0] as unknown as File,
          endpoint: URL_FILES,
          token: TOKEN_FILES
        });
        if (resFile.status !== 201) {
          openNotification('error', resFile.message || 'Error al subir el archivo');
          return;
        }
        values.uuid_file = resFile.data ? resFile.data.UUID_file : "";
      }


      createContractMutation(values, {
        onSuccess: () => {
          openNotification('success', 'Éxito', 'Contrato guardado correctamente');
          form.resetFields();
          setFileList([]);
          navigate('/contratos');
        },
        onError: (error) => {
          openNotification('error', 'Error', error.message);
        }
      });
    } catch (error: any) {
      openNotification('error', 'Error', error.message || 'Ocurrió un error inesperado');
    }
  };


  return (
    <section
      style={{
        background: token.colorBgLayout,
        minHeight: '100vh'
      }}
    >
      {/* ── Header ── */}
      <HeaderApp sectionName="Agregar nuevo contrato" showBack />

      {/* ── Form Container ── */}
      <section
        style={{
          display: 'block',
          margin: "0 auto",
          padding: "28px 24px 100px",
        }}
      >
        <ContractFrom
          form={form}
          onFinish={handleFinish}
          isCreating={isCreating}
          isUploading={isUploading}
          fileList={fileList}
          setFileList={setFileList}
        />
      </section>
    </section>
  );
};

export default UploadContract;